import React from "react";
import usePageMeta from "../../utils/usePageMeta";
import Section3 from "../../components/Section3";

const PortfolioPage = () => {
  usePageMeta({
    title: "Portfolio",
    description:
      "Case studies of shipped products: live-streaming and fan community apps, barbershop booking app, CRM and admin dashboards, AI nail-sizing app and corporate websites.",
    path: "/portfolio",
  });
  return (
    <div className="mt-20 min-h-screen">
      <Section3 />
    </div>
  );
};

export default PortfolioPage;
